
import React, { Component } from 'react';
import { Checkbox } from 'antd';

export class RangeType extends Component {

    handleChangeRange = (value) => {
        const { onChange } = this.props;
        onChange(value);
    }

    render() {
        const { value, disabled, typeOption } = this.props;
        return (
            <div className="department">
                <Checkbox
                    onChange={() => this.handleChangeRange(0)}
                    checked={value === 0}
                >
                    Một số trong khi vực được chọn
                </Checkbox>
                <Checkbox 
                    onChange={() => this.handleChangeRange(1)}
                    checked={value === 1}
                >
                    Tất cả trong khu vực được chọn
                </Checkbox>
            </div>
        )
    }
}